var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcManjarGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87d7d6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.67,31.94H46.33a2.15,2.15,0,0,0,2.15-2.15h0a3,3,0,0,0-3-3H44.18V24.63a3,3,0,0,0-.88-2.12,3,3,0,0,0-2.13-.88h-.43a8.69,8.69,0,0,0-3-6.52,13.12,13.12,0,0,0-3.68-2.42,1.35,1.35,0,0,0-.93,0,1.3,1.3,0,0,0-.8,1.53,1.25,1.25,0,0,1-.22.75c-.3.44-1.18,1.22-3.76,1.56a11.94,11.94,0,0,0-8.54,5.11h-1a3,3,0,0,0-2.13.88,3,3,0,0,0-.88,2.12v2.15H14.53a3,3,0,0,0-3,3A2.15,2.15,0,0,0,13.67,31.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,33.22H11a3,3,0,0,0-3,3,2.15,2.15,0,0,0,2.15,2.18h.51v4.3a4.75,4.75,0,0,0,4.73,4.73H44.61a4.75,4.75,0,0,0,4.73-4.73v-4.3h.48a2.18,2.18,0,0,0,.94-.2A2.13,2.13,0,0,0,52,36.23h0A3,3,0,0,0,49,33.22Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcManjarGreen);
export default __webpack_public_path__ + "static/media/DC__Manjar_green.7d83729947227ff8ca77408867616a27.svg";
export { ForwardRef as ReactComponent };